import { Input } from "@/components/ui/Input";
import { useStepContext } from "@/hooks/useSetupWizard";
import * as shared from "@/styles/shared";
import { Building2, Lock, User } from "lucide-react";
import * as pageStyles from "../../pages/SetupWizardPage.styles";
import * as styles from "./ProviderStep.styles";

const ProviderStep = () => {
  const step = useStepContext();

  if (!step.selectedAddressId) return null;

  return (
    <div className={pageStyles.section}>
      <h2 className={shared.headingLg}>{step.t("step3Title")}</h2>
      <p className={shared.muted}>{step.t("step3Desc")}</p>
      <div className={shared.formStack}>
        <div className={styles.wrapper}>
          <label htmlFor="provider-select" className={styles.label}>
            {step.t("selectProviderLabel")}
          </label>
          <div className={styles.relative}>
            <select
              id="provider-select"
              value={step.selectedProviderId}
              onChange={(e) => step.setState({ selectedProviderId: e.target.value })}
              className={`${pageStyles.select} ${styles.selectPadding}`}
              required
            >
              <option value="">{step.t("selectProvider")}</option>
              {step.providers.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name}
                </option>
              ))}
            </select>
            <Building2 className={shared.inputIcon} />
          </div>
        </div>
        <Input
          id="provider-username"
          label={step.t("step.providerUsername")}
          value={step.providerUsername}
          onChange={(e) => step.setState({ providerUsername: e.target.value })}
          placeholder={step.t("providerUsernamePlaceholder")}
          icon={User}
        />
        <Input
          id="provider-password"
          label={step.t("step.providerPassword")}
          value={step.providerPassword}
          onChange={(e) => step.setState({ providerPassword: e.target.value })}
          placeholder={step.t("providerPasswordPlaceholder")}
          type="password"
          icon={Lock}
        />
        <label className={pageStyles.checkboxLabel}>
          <input type="checkbox" checked={step.providerSkipPayment} onChange={(e) => step.setState({ providerSkipPayment: e.target.checked })} />
          {step.t("skipPayment")}
        </label>
        <label className={pageStyles.checkboxLabel}>
          <input type="checkbox" checked={step.providerTaxDeduction} onChange={(e) => step.setState({ providerTaxDeduction: e.target.checked })} />
          {step.t("taxDeduction")}
        </label>
        {step.providerTaxDeduction && (
          <Input
            id="tax-deduction-amount"
            label={step.t("taxDeductionAmount")}
            value={step.providerTaxDeductionAmount}
            onChange={(e) => step.setState({ providerTaxDeductionAmount: e.target.value })}
            placeholder={step.t("taxDeductionAmount")}
            type="number"
            step="0.01"
            min="0"
          />
        )}
      </div>
    </div>
  );
};

export { ProviderStep };
